import { Box, useMediaQuery } from '@mui/material';
import React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { myTheme } from '../../../../shared/theme';

export default function ReportGraph(params: any) {
    const isMobile = useMediaQuery('(max-width: 770px)');

    const boat = params?.data.filter((i: any) => i.moduleType === 'boat');
    const vehicle = params?.data.filter((i: any) => i.moduleType === 'vehicle');
    const property = params?.data.filter(
        (i: any) => i.moduleType === 'property',
    );
    const activity = params?.data.filter(
        (i: any) => i.moduleType === 'activity',
    );
    const commercial = params?.data.filter(
        (i: any) => i.moduleType === 'commercial',
    );

    const totals = [
        { name: 'Boat', total: boat?.length },
        { name: 'Vehicle', total: vehicle?.length },
        { name: 'Property', total: property?.length },
        { name: 'Activity', total: activity?.length },
        { name: 'Commercial', total: commercial?.length },
    ];

    return (
        <Box
            sx={{
                height: isMobile ? 400 : 800,
                width: '100%',
                paddingTop: isMobile ? '0px' : '50px',
            }}
        >
            <BarChart
                tooltip={{ trigger: 'item' }}
                xAxis={[
                    {
                        id: 'barCategories',
                        data: totals.map(
                            (reservation: { name: any }) => reservation?.name,
                        ),
                        scaleType: 'band',
                    },
                ]}
                series={[
                    {
                        data: totals.map(
                            (reservation: { total: any }) => reservation?.total,
                        ),
                        color: myTheme.secondary.main,
                    },
                ]}
            />
        </Box>
    );
}
